<script setup lang="ts">
import { computed } from 'vue'
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { usePlayer } from '@/composables/game/player'
import { useMultiplayerMine } from '@/composables/game/multiplayer-mine'
import mineIcon from '@/assets/images/multiplayer/mine-icon.png'
import mineAntimineIcon from '@/assets/images/multiplayer/mine-antimine-icon.png'
import mineMagnetIcon from '@/assets/images/multiplayer/mine-magnet-icon.webp'

defineProps<{
  show: boolean
}>()

const emit = defineEmits<{
  hide: []
}>()

const { player } = usePlayer()
const { openUseMagnetOverlay } = useMultiplayerMine()

const antiMineCount = computed(() => (player.value.specialCurrencies as Record<string, number>)['mp.antiMine'] ?? 0)
const magnetCount = computed(() => (player.value.specialCurrencies as Record<string, number>)['mp.mineMagnet'] ?? 0)
</script>

<template>
  <TheBottomSheet
    :show="show"
    centered
    :close-button="true"
    @hide="emit('hide')"
  >
    <div class="flex flex-col items-center">
      <img
        :src="mineIcon"
        class="w-[120px] h-[120px] object-contain"
        alt="Mine"
      >

      <h2 class="font-pilat font-bold text-[24px] leading-8 text-white text-center">
        YOU'VE BEEN MINED!
      </h2>

      <p class="text-white/60 text-base font-semibold text-center mb-6">
        Upgrade a mined card and lose coins. Use Magnets to take the mines (they're yours now!), or block with Anti-Mines.
      </p>

      <div class="w-full flex gap-3">
        <div class="flex-1 bg-[#1d1d1d] border-2 border-[#626262a8] rounded-xl p-3 flex flex-col items-center justify-center gap-3">
          <img
            :src="mineAntimineIcon"
            class="w-12 h-12 object-contain"
            alt="Anti-Mine"
          >
          <span class="text-white font-bold text-[32px] leading-6 count-shadow -mt-6 ">{{ antiMineCount }}</span>
          <span class="text-white text-sm font-bold uppercase">Anti-Mines</span>
        </div>
        <div
          class="flex-1 bg-[#1d1d1d] border-2 border-[#626262a8] rounded-xl p-3 flex flex-col items-center justify-center gap-3 cursor-pointer"
          @click="magnetCount > 0 && (openUseMagnetOverlay(), emit('hide'))"
        >
          <img
            :src="mineMagnetIcon"
            class="w-12 h-12 object-contain"
            alt="Magnet"
          >
          <span class="text-white font-bold text-[32px] leading-6 count-shadow -mt-6">{{ magnetCount }}</span>
          <span class="text-white text-sm font-bold uppercase">Magnets</span>
        </div>
      </div>
    </div>
  </TheBottomSheet>
</template>

<style scoped lang="scss">
.count-shadow {
  text-shadow: 0 0 4px #000;
}
</style>
